<div class="divider"></div>

<div class="row">
  <div class="col">
    <h3 class="h5">
      <span translate>Error / Status signal configuration</span>
      @if (isLoadingDetails) {
        <span
        class="fa-solid fa-spinner fa-spin"></span>
      }
    </h3>
  </div>
  <div class="col-auto">
    <div class="custom-control custom-switch d-inline-flex">
      <input (change)="onChangeCsvMappingDisabledFlag()" [(ngModel)]="signal.statusEventsDetails.csvMappingDisabled"
        [disabled]="!isHigherThanAdmin"
        class="custom-control-input"
        id="disableCsvMapping"
        type="checkbox">
        <label class="custom-control-label" for="disableCsvMapping" translate>disable CSV mapping</label>
      </div>
    </div>
  </div>

  @if (!isLoadingDetails && !signal.statusEventsDetails.csvMappingDisabled) {
    <div>
      <div class="form-row align-items-end">
        <div class="col">
          <div class="input-group mb-0">
            <div class="input-group-prepend">
              <span class="input-group-text" translate>Parsing Type</span>
            </div>
            <ng-select (change)="onParsingTypeChange()"
              [(ngModel)]="signal.statusEventsDetails.parsingType"
              [clearable]="false"
              [items]="parsingTypes"
              [ngModelOptions]="{standalone: true}"
              [disabled]="!isHigherThanAdmin"
              bindLabel="value"
              bindValue="key" class="flex-fill">
            </ng-select>
          </div>
        </div>
        <div class="col-auto">
          <scitis-file-upload
            (fileLoadError)="onFileUploadError($event)"
            (fileLoadEvent)="onFileUploadComplete($event)"
            [fileType]="uploadControlConfiguration.fileType"
            [isDisabled]="isLoadingDetails || !isHigherThanAdmin"
            [label]="uploadControlConfiguration.label"
            [loadingIndicatorMessage]="uploadControlConfiguration.message"
            [maxFileSize]="uploadControlConfiguration.maxUploadFileSize"
            [title]="uploadControlConfiguration.title">
          </scitis-file-upload>
        </div>
      </div>
      <!--EVENT CONFIGURATION EXIST INDICATOR-->
      <div class="alert alert-secondary mt-3">
        <div class="form-row align-items-center">
          <div class="col">
            @if (!isLoadingDetails && signal.statusEventsDetails.definitions.size <= 0) {
              <div class="text-center">
                <span class="fa-solid fa-circle-exclamation mr-2"></span>
                <span translate>Configuration missing, please upload a CSV file.</span>
              </div>
            }
            @if (!isLoadingDetails && signal.statusEventsDetails.definitions.size >0) {
              <div>
                <span class="fa-solid fa-circle-check mr-2 text-success" ngbTooltip="{{'Event configuration present' | translate}}"
                placement="top"></span>
                <span [innerText]="generateExportFileName()"></span>
              </div>
            }
          </div>
          <!--DOWNLOAD CONFIGURATION-->
          @if (!shouldDisableButton()) {
            <div class="col-auto">
              <scitis-file-download
                (prepareDownloadContent)="onFileDownloadRequested($event)"
                [downloadDetails]="downloadControlConfiguration.details"
                [fileName]="downloadControlConfiguration.fileName"
                [fileType]="downloadControlConfiguration.fileType"
                [label]="downloadControlConfiguration.label"
                [title]="downloadControlConfiguration.title"
                [isDisabled]="!isHigherThanAdmin">
              </scitis-file-download>
              <!--PREVIEW CONFIGURATION-->
              <button (click)="onShowPreview()"
                [title]="previewControlConfiguration.title"
                [disabled]="!isHigherThanAdmin"
                class="btn btn-outline-primary btn-sm ml-1"
                type="button">
                <span>
                  <span class="fa-solid fa-eye"></span>
                  @if (previewControlConfiguration.label) {
                    <span
                    [innerText]="previewControlConfiguration.label"></span>
                  }
                </span>
              </button>
              <!--REMOVE CONFIGURATION-->
              <button (click)="onRemoveConfiguration()"
                [title]="deleteControlConfiguration.title"
                [disabled]="!isHigherThanAdmin"
                class="btn btn-outline-danger btn-sm ml-1"
                type="button">
                <span>
                  <span class="fa-solid fa-trash"></span>
                  @if (deleteControlConfiguration.label) {
                    <span
                    [innerText]="deleteControlConfiguration.label"></span>
                  }
                </span>
              </button>
            </div>
          }
        </div>
      </div>
      @if (outcomeOfParsingCSV && outcomeOfParsingCSV.length>0) {
        <div class="row">
          <div class="col-12">
            <h3 class="h6" translate>Parsing Outcome</h3>
            <div class="alert alert-info">
              <pre [innerHTML]="outcomeOfParsingCSV" class="pre-scrollable mb-0"></pre>
            </div>
          </div>
        </div>
      }
    </div>
  }
